import * as React from "react";
import type { SectionDisplayProps } from "../section-content-display";

const SectionSingle = (props: SectionDisplayProps) => {
    return <div>SECTION SINGLE {props.sectionTheme.asString}</div>;
};

export { SectionSingle };
